import update from 'react-addons-update';

import {
  FB_PAGES_DATA,
  SELECT_AGENT_NAME_FOR_FB_PAGE,
  DELETE_FB_PAGE,
} from '../types/fbPagesData';

export const fbPagesDataReducer = (state = [], action) => {
  switch (action.type) {
    case FB_PAGES_DATA:
      return getFBPagesData(state, action);
    case SELECT_AGENT_NAME_FOR_FB_PAGE:
      return selectAgentNameForFBPage(state, action);
    case DELETE_FB_PAGE:
      return deleteFBPage(state, action);
    default:
      return state;
  }
};

function getFBPagesData(state, action) {
  const { data } = action.payload;
  const fbPagesData = data;
  let result = '';

  if (fbPagesData.length > 0) {
    result = fbPagesData;
  } else {
    result = [];
  }
  return result;
}

function selectAgentNameForFBPage(state, action) {
  const pageData = action.payload.pageData;
  const index = action.payload.index;

  if (state.length > 0) {
    return update(state, {
      [index]: { $merge: pageData },
    });
  }
}

function deleteFBPage(state, action) {
  const fbPagesData = action.payload.fbPagesData;
  const pageData = action.payload.pageData;
  let index = '';
  for (const item of fbPagesData) {
    if (item.fb_pageid == pageData.fb_pageid) {
      index = fbPagesData.indexOf(item);
    }
  }

  if (state.length > 0) {
    state.splice(index, 1);
  }
  return [...state];
}
